import {
  AddScheduleTemplateApiCallPayload,
  EditScheduleTemplateRequestApiCallPayload,
  RemoveScheduleTemplateRequestPayload
} from '@/redux/scheduleTemplates/types'
import { httpClient } from './httpClient'

export async function getScheduleTemplates () {
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url: import.meta.env.VITE_GET_SCHEDULES_TEMPLATES_ENDPOINT,
      withCredentials: true,
      method: 'GET',
      cache: false
    })

    return response?.data
  } catch (error) {
    console.error('getScheduleTemplates - Error: ', error)
    throw error
  }
}

export async function getSingleScheduleTemplate ({ id }: { id: number }) {
  try {
    let url = import.meta.env.VITE_GET_SCHEDULE_TEMPLATE_ENDPOINT
    url = url.replace('__scheduleId__', id.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'GET',
      cache: false
    })

    return response.data
  } catch (error) {
    console.error('getSingleScheduleTemplate - Error: ', error)
    throw error
  }
}

export async function deleteScheduleTemplate ({
  id
}: RemoveScheduleTemplateRequestPayload) {
  try {
    let url = import.meta.env.VITE_DELETE_SCHEDULE_TEMPLATE_ENDPOINT
    url = url.replace('__scheduleId__', id.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'DELETE'
    })

    return response
  } catch (error) {
    console.error('deleteScheduleTemplate - Error: ', error)
    throw error
  }
}

export async function editScheduleTemplate ({
  id,
  fieldsToEdit
}: EditScheduleTemplateRequestApiCallPayload) {
  try {
    let url = import.meta.env.VITE_EDIT_SCHEDULE_TEMPLATE_ENDPOINT
    url = url.replace('__scheduleId__', id.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'PUT',
      data: fieldsToEdit
    })

    return response
  } catch (error) {
    console.error('editScheduleTemplate - Error: ', error)
    throw error
  }
}

export async function addScheduleTemplate ({
  name,
  description,
  share,
  totalDays,
  manageType,
  parentTemplateId,
  exercises
}: AddScheduleTemplateApiCallPayload) {
  try {
    const url = import.meta.env.VITE_CREATE_SCHEDULE_TEMPLATE_ENDPOINT

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'POST',
      withCredentials: true,
      data: {
        name,
        description,
        manageType,
        totalDays,
        share,
        parentTemplateId,
        exercises
      }
    })

    return response
  } catch (error) {
    console.error('addScheduleTemplate - Error: ', error)
    throw error
  }
}
